import React from "react";

const OxygenOutlined = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2926_9917"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2926_9917)">
        <path
          d="M10.2406 16.2499C10.0366 16.2499 9.86266 16.178 9.71891 16.0343C9.5753 15.8906 9.5035 15.7168 9.5035 15.5126V12.2434C9.5035 12.0394 9.5753 11.8655 9.71891 11.7218C9.86266 11.5781 10.0366 11.5063 10.2406 11.5063H12.2597C12.4638 11.5063 12.6377 11.5781 12.7814 11.7218C12.9252 11.8655 12.997 12.0394 12.997 12.2434V15.5126C12.997 15.7168 12.9252 15.8906 12.7814 16.0343C12.6377 16.178 12.4638 16.2499 12.2597 16.2499H10.2406ZM10.497 15.2563H12.0035V12.4999H10.497V15.2563ZM14.247 18.2051V16.0736C14.247 15.8642 14.3175 15.689 14.4585 15.548C14.5995 15.4069 14.7747 15.3363 14.9841 15.3363H16.7631V14.4551H14.247V13.4613H17.0193C17.2288 13.4613 17.404 13.5319 17.545 13.673C17.6861 13.814 17.7566 13.9892 17.7566 14.1986V15.5928C17.7566 15.8022 17.6861 15.9775 17.545 16.1184C17.404 16.2595 17.2288 16.3301 17.0193 16.3301H15.2406V17.2113H17.7566V18.2051H14.247ZM7.67641 17.8828C6.04294 17.7259 4.70238 17.048 3.65475 15.8493C2.60725 14.6505 2.0835 13.2007 2.0835 11.4999C2.0835 10.2071 2.60086 8.79016 3.63558 7.24905C4.6703 5.70794 6.23627 4.02877 8.3335 2.21155C9.9478 3.60141 11.2477 4.92134 12.2333 6.17134C13.2188 7.42134 13.8874 8.59065 14.2389 9.67926H12.9345C12.5969 8.84176 12.0443 7.93717 11.2766 6.96551C10.509 5.9937 9.52794 4.96349 8.3335 3.87488C6.68072 5.38877 5.43419 6.7846 4.59391 8.06238C3.75363 9.34016 3.3335 10.486 3.3335 11.4999C3.3335 12.8653 3.73627 14.0207 4.54183 14.9661C5.34738 15.9117 6.39225 16.463 7.67641 16.6201V17.8828Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default OxygenOutlined;
